import type { ChannelRecord } from '@nadoutong/contracts';

export const CHANNEL_BRANDS = [
  { id: 'nadoutong', label: 'Nadoutong' },
  { id: 'nxtpath', label: 'Nxtpath' },
] as const;

export type ChannelBrandId = (typeof CHANNEL_BRANDS)[number]['id'];

type ChannelBrandProfileRecord = NonNullable<ChannelRecord['brand_profiles']>[number];

export function profileForBrand(
  channel: ChannelRecord,
  brand: ChannelBrandId,
): ChannelBrandProfileRecord | null {
  return channel.brand_profiles?.find((profile) => profile.brand === brand) ?? null;
}

export function enabledBrandProfiles(
  channel: ChannelRecord,
): ChannelBrandProfileRecord[] {
  return CHANNEL_BRANDS.flatMap(({ id }) => {
    const profile = profileForBrand(channel, id);
    return profile?.enabled === true ? [profile] : [];
  });
}

export function brandLabel(brand: ChannelBrandId | string): string {
  return CHANNEL_BRANDS.find((option) => option.id === brand)?.label ?? brand;
}
